import { useEffect, useState } from "react";
import { http } from "../../axios/axios";
import DynamicBanner from "../DynamicBanner";

function Banner() {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getBanners = async () => {
      try {
        setBanners([]);
        const res = await http.get("/banners/page/home");
        setBanners(res.data.data || []);
      } catch (err) {
        console.error(err);
        setBanners([]);
      } finally {
        setLoading(false);
      }
    };

    getBanners();
  }, []);

  return <DynamicBanner key="home" banners={banners} loading={loading} />;
}

export default Banner;
